module.exports = __webpack_public_path__ + "img/43cd1fa.png";